import { FC } from 'react'
import type { IconProps } from '../types'

const WarningFilledIcon: FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11 17H13V15H11V17ZM11 13H13V7H11V13Z'
      fill={color}
    />
  </svg>
)

export default WarningFilledIcon
